import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation } from '@angular/core';
import { SvgComponent } from 'icon';

@Component({
  selector: 'lib-curved-box',
  templateUrl: './curved-box.component.html',
  styleUrls: ['./curved-box.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, SvgComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurvedBoxComponent {
  public backgroundImage = input<string>();
  public horizontalLines = input<'top' | 'bottom' | 'both' | 'none'>('none');
  public curve = input<'top' | 'bottom' | 'both' | 'top-inside' | 'none'>('both');
  public height = input<'1/2' | '3/4' | 'auto'>();
  public showOverflow = input(false);
  public lightTheme = input(false);
  public additionalClasses = input<{ [klass: string]: boolean }>();
  public mergedClasses = computed(() => ({
    'bg-linear-50': this.height() === '1/2',
    'bg-linear-75': this.height() === '3/4',
    'bg-cover': this.height() === 'auto',
    'pb-11': this.curve() === 'bottom' || this.curve() === 'both',
    'pt-8': this.curve() === 'top' || this.curve() === 'both',
    'overflow-hidden': !this.showOverflow(),
    'bg-[image:var(--color-primary-default)]': !this.lightTheme(),
    'bg-[--color-background-curved-box-light]': this.lightTheme(),
    ...this.additionalClasses(),
  }));
  public bottomCurveClasses = computed(() => {
    const classes = ['mt-1'];
    const height = this.height();

    if (height === '1/2') {
      classes.push('top-1/2', 'w-full', 'absolute');
    } else if (height === '3/4') {
      classes.push('top-3/4', 'w-full', 'absolute');
    }

    return classes;
  });
}
